

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { GroupModel } from '@/models/Group';
import OperatorTip from './OperatorTip.vue';

const module = namespace('GroupStore');

@Component({
  components: {
    OperatorTip,
  },
})
export default class GroupCard extends Vue {
    @Prop() private group!: GroupModel;

    @module.Action('changedDrawable') private changedDrawable!: () => void;

    get classByRarity() {
        if (this.group.operators.length) {
            const maxRarity = this.group.operators.reduce((a, b) => a.rarity > b.rarity ? a:b).rarity;
            return 'flex-box group-card ' + 'rarity' + String(maxRarity) + '-backcolor';
        } else {
            return '';
        }
    }

    private isVisible() {
        if (this.group.id === 0) {
            return false;
        } else {
            return true;
        }
    }

    private clickDrawable() {
        this.changedDrawable();
    }
}
